import { Fragment, useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { Btn } from "../../../../../AbstractElements";
import BerlinModalForm from "./BerlinModalForm";
import { BerlinSignUp, OpenModalBerlin } from "../../../../../Constants/Constants";

const BerlinModal = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <Fragment>
      <Btn color="primary" onClick={toggle}>{OpenModalBerlin}</Btn>
      <Modal isOpen={modal} toggle={toggle}>
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="justify-content-center border-0">{BerlinSignUp}</ModalHeader>
          <BerlinModalForm />
        </div>
      </Modal>
    </Fragment>
  );
};
export default BerlinModal